<template>
    <div class="other-comment">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <div class="comment-fate-topbar">
            <!-- 1、顶部菜单栏 -->
            <div class="comment-title-bar dsp-flex">
                <div class="comment-title-side">
                    <span v-if="fromEmbedded" class="comment-title-back" @click="clickClose">
                        <i class="iconfont icon-guanbi"></i>
                    </span>
                    <span v-else class="comment-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                </div>
                <div class="comment-title-mid">
                    <span>他人批盘</span>
                </div>
                <div class="comment-title-side"></div>
            </div>
        </div>
        <!-- 2、他人排盘列表 -->
        <div class="other-comment-list" v-if="otherCommentList.length > 0">
            <comment-other-item
                v-for="commentData of otherCommentList"
                v-bind:key="'other-comment' + commentData.id + Math.random(0, 10)"
                v-bind:commentData="commentData"
                v-bind:itemFunc="clickCommentItem"
                v-bind:editFunc="clickCommentItemEdit">
            </comment-other-item>
        </div>
        <no-data
            v-else
            v-bind:noteText="'记录空空如也~'">
        </no-data>

        <!-- 3、底部菜单栏 -->
        <comment-bottom-bar></comment-bottom-bar>

        <!-- 4、修改他人批盘名称 -->
        <van-dialog v-model="showEditPop" title="修改批盘名" v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" placeholder="请输入批盘名称" v-model="inputPiPanName" maxlength="25" v-to-focus-edit-other-comment-title='true' autofocus  />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import CommentBottomBar from '../../layouts/comment/CommentBottomBar.vue'
import CommentOtherItem from '../../layouts/comment/CommentOtherItem.vue'
import { SHARE } from '../../modules/share';
import { SCHEME } from '../../modules/utils';
import { DATA } from '../../modules/data';
export default {
    name: 'OtherComment',
    directives : {
        "to-focus-edit-other-comment-title" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    components: { NoData, CommentBottomBar, CommentOtherItem },
    computed: {
        detailInfo() {
            return this.$store.state.comment.detailInfo;
        },
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        otherCommentList() {
            return this.$store.state.othercomment.otherCommentList;
        }
    },
    data() {
        return {
            showEditPop: false,
            inputPiPanName: '',
            curEditData: {}
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
        },
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('embedded/resetData');
        },
        clickBack() {
            // console.log('OtherComment-----clickBack-----', initDetail)
            // 添加状态:从八字打开的时候就返回八字，从分享来的八字批盘打开的时候返回列表
            var initDetail = this.$store.state.detail.initDetail;
            if(!initDetail) {
                this.$store.dispatch("detail/initDetail", this.detailInfo);
            }
            // 重置数据:同批盘页Comment.vue
            this.$router.replace("/detail/record/" + this.detailInfo.id);
            this.$store.dispatch("comment/resetData");
            this.$store.dispatch("othercomment/resetData");
            this.$store.dispatch("minifatefortune/resetMiniData");
            setTimeout(() => {
                SHARE.initConfigShare();
            }, 10);
        },
        clickCommentItem(data) {
            // 查看他人批盘
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            // console.log('clickCommentItem-----', data, personInfo)
            // 重置数据
            this.$store.dispatch("comment/resetData");
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch("comment/initOtherPiPan", {
                detailData: personInfo,
                pipanData: data.pipan
            });
            // 他人批盘的分享数据设置
            this.$store.state.comment.otherShareTitle = data.title;
            this.$store.state.comment.otherShareCode = data.share;

            setTimeout(() => {
                me.$router.replace('/comment/othercomment/' + personInfo.id);
                SHARE.initConfigShare();
            }, 100);
        },
        clickCommentItemEdit(data) {
            this.curEditData = data;
            this.inputPiPanName = data.title;
            this.showEditPop = true;
        },
        beforeClose(action, done) {
            window.scrollTo(0, 0);
            if (action === 'confirm') {
                if(this.inputPiPanName != ''){
                    console.log('-------', this.inputPiPanName, this.curEditData)
                    // 名称不为空
                    if(this.inputPiPanName == this.curEditData.title){
                        this.$toast("名称未改变");
                        done();
                        return;
                    }
                    this.$store.dispatch('othercomment/editOtherPiPanData', {
                        id: this.curEditData.id,
                        title: this.inputPiPanName
                    })
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },

    }
}
</script>